<template>
    <header class="mb-4">
        <div
            class="relative"
            v-if="
                activeRedemption?.hotel &&
                activeRedemption?.redemption_type?.slug === 'hotel'
            "
        >
            <ImageLoader>
                <template #image>
                    <img
                        :src="activeRedemption?.hotel?.image_location"
                        class="w-full h-52 object-cover rounded-lg mb-4"
                    />
                </template>
                <template #preloader>
                    <div
                        class="w-full h-52 object-cover rounded-lg mb-4 bg-slate-200 shimmer"
                    ></div>
                </template>
                <template #error>
                    <div
                        class="w-full h-52 object-cover rounded-lg mb-4 flex items-center justify-center text-center flex-col bg-slate-100 border border-slate-200"
                    >
                        <Icon icon="no-image" />
                        <p class="text-sm text-slate-600">No Image</p>
                    </div>
                </template>
            </ImageLoader>
            <div
                class="absolute bottom-2 right-2 bg-white p-1 bg-opacity-90 rounded justify-center items-center flex"
                v-if="activeRedemption?.hotel?.program?.program_image"
            >
                <img
                    :src="`${cdnUrl}/${activeRedemption?.hotel?.program?.program_image?.path}/_small/${activeRedemption?.hotel?.program?.program_image?.file_name}`"
                    class="max-w-[68px] h-auto max-h-7"
                />
            </div>
        </div>
        <div
            class="flex gap-4 mb-4 items-center sm:items-start"
            :class="
                activeRedemption?.hotel &&
                activeRedemption?.redemption_type?.slug === 'hotel'
                    ? 'items-start'
                    : 'items-center'
            "
        >
            <div
                class="w-12 min-w-12 min-h-12 h-12 flex bg-[#fff1e4] text-[#ff7d01] rounded-full justify-center items-center"
            >
                <TripsIcon
                    class="text-[#ff7d01]"
                    :icon="activeRedemption?.redemption_type?.icon"
                />
            </div>
            <div>
                <h3 class="text-slate-800 text-xl font-medium">
                    {{ panelTitle }}
                </h3>
                <address
                    class="text-slate-500 text-sm not-italic hidden sm:block"
                    v-if="
                        activeRedemption?.hotel &&
                        activeRedemption?.redemption_type?.slug === 'hotel'
                    "
                >
                    {{ activeRedemption?.hotel?.address_1 }},
                    {{ activeRedemption?.hotel?.locality }}
                    {{ activeRedemption?.hotel?.region }}
                    {{ activeRedemption?.hotel?.postal_code }},
                    {{ activeRedemption?.hotel?.country }}
                </address>
            </div>
        </div>
        <div class="flex items-center gap-4" v-if="!isSharedView">
            <button
                class="btn btn-secondary flex items-center gap-2"
                @click="editRedemption()"
            >
                <Icon icon="pencil" />
                <span>Edit</span>
            </button>
            <button
                class="btn btn-secondary flex items-center gap-2"
                @click="tripsStore.setShowDeleteRedemptionConfirm(true)"
            >
                <Icon icon="trash" />
                <span>Delete</span>
            </button>
        </div>
    </header>
</template>
<script setup>
import { computed } from 'vue';
import { useTripsStore } from '@/store/trips';
import TripsIcon from '@/components/trips/icons.vue';
import Icon from '@/components/ui/icon/icon.vue';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';
import { useTripTitles } from '@/composables/tripTitles';

const tripsStore = useTripsStore();

const props = defineProps({
    activeRedemption: Object,
    isSharedView: {
        type: Boolean,
        default: false,
    },
});

const cdnUrl = computed(() => window.cdnUrl);

const redemptionRef = computed(() => props.activeRedemption);
const { flightTitle, trainTitle, rentalTitle } = useTripTitles(redemptionRef);

const editRedemption = () => {
    tripsStore.setActiveRedemption(props.activeRedemption);
    tripsStore.setShowRedemptionEditModal(true);
};

const panelTitle = computed(() => {
    if (props.activeRedemption?.redemption_type?.slug === 'flight') {
        return flightTitle.value;
    }

    if (props.activeRedemption?.redemption_type?.slug === 'train') {
        return trainTitle.value;
    }

    if (props.activeRedemption?.redemption_type?.slug === 'rental-car') {
        return rentalTitle.value;
    }

    return props.activeRedemption?.name;
});
</script>
